(function() {
    'use strict';
    angular
        .module('MW.Framework.Editor.v5', [
            'MW.Framework.CoreCompanyService',
            'MW.Framework.CoreUserService',
            'MW.Framework.TranslationService',
            'MW.Influencers.IcmDialogService',
            'Configuration'
        ])
        .directive('tinymceEditorV5', [
            '$timeout',
            '$parse',
            'CoreCompanyService',
            'CoreUserService',
            'translationService',
            'DialogService',
            'FILE_UPLOADER_URL',
            'ICM_ASSETS_URL',
            function ($timeout,
                      $parse,
                      CoreCompanyService,
                      CoreUserService,
                      translationService,
                      DialogService,
                      FILE_UPLOADER_URL,
                      ICM_ASSETS_URL
            ) {
                var randomEditorId = Math.ceil(Math.random() * 10000);

                return {
                    restrict: 'A',
                    require: 'ngModel',
                    link: function(scope, elem, attrs, ngModel) {
                        translationService.waitForTranslations().then(function() {
                            var options,
                                customOptions,
                                editorInstance,
                                updateView,
                                imageUploadHandlerFn,
                                imageUploadAcceptedTypes = 'image/jpeg, image/jpg, image/png, image/gif, image/svg+xml',
                                uploadingImageMessage = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--uploading-image-message'),
                                genericErrorMessage = translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.'),
                                fixedStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-family-fixed'),
                                wideStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-family-wide'),
                                narrowStr = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--font-family-narrow'),
                                firstNameText = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--first-name'),
                                firstNamePlaceholder = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--first-name-placeholder'),
                                lastNameText = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--last-name'),
                                lastNamePlaceholder = translationService.getLocalizedString('icm-web-influencers-outreach-compose__tinymce-editor--last-name-placeholder'),
                                uploading = false,
                                editorLanguageMap = {
                                    da: 'da',     // danish
                                    de: 'de',     // german
                                    en: null,  // english (default)
                                    es: 'es',     // spanish
                                    fi: 'fi',     // finnish
                                    fr: 'fr_FR',  // french
                                    ja: 'ja',     // japanese
                                    nb: 'nb_NO',  // norwegian
                                    nl: 'nl',     // dutch
                                    pt: 'pt_PT',  // portuguese
                                    sv: 'sv_SE',  // swedish
                                    /* jshint camelcase: false */
                                    zh_CN: 'zh_CN',   // chinese (simplified)
                                    /* jshint camelcase: false */
                                    zh_TW: 'zh_TW'    // chinese (traditional)
                                },
                                editorColorMap = [
                                    '#000000', 'Black',
                                    '#993300', 'Burnt orange',
                                    '#333300', 'Dark olive',
                                    '#003300', 'Dark green',
                                    '#003366', 'Dark azure',
                                    '#000080', 'Navy Blue',
                                    '#333399', 'Indigo',
                                    '#333333', 'Very dark gray',

                                    '#800000', 'Maroon',
                                    '#FF6600', 'Orange',
                                    '#808000', 'Olive',
                                    '#008000', 'Green',
                                    '#008080', 'Teal',
                                    '#0000FF', 'Blue',
                                    '#666699', 'Grayish blue',
                                    '#808080', 'Gray',

                                    '#FF0000', 'Red',
                                    '#FF9900', 'Amber',
                                    '#99CC00', 'Yellow green',
                                    '#339966', 'Sea green',
                                    '#33CCCC', 'Turquoise',
                                    '#3366FF', 'Royal blue',
                                    '#800080', 'Purple',
                                    '#999999', 'Medium gray',

                                    '#FF00FF', 'Magenta',
                                    '#FFCC00', 'Gold',
                                    '#FFFF00', 'Yellow',
                                    '#00FF00', 'Lime',
                                    '#00FFFF', 'Aqua',
                                    '#00CCFF', 'Sky blue',
                                    '#993366', 'Red violet',
                                    '#FFFFFF', 'White',

                                    '#FF99CC', 'Pink',
                                    '#FFCC99', 'Peach',
                                    '#FFFF99', 'Light yellow',
                                    '#CCFFCC', 'Pale green',
                                    '#CCFFFF', 'Pale cyan',
                                    '#99CCFF', 'Light sky blue',
                                    '#CC99FF', 'Plum'
                                ],
                                editorLanguage = editorLanguageMap.hasOwnProperty(CoreUserService.getLanguage()) ? editorLanguageMap[CoreUserService.getLanguage()] : null;

                            //setElementAttributes, createFormats,
                            //we're now using this Handler for powerPaste and custom imageUpload
                            imageUploadHandlerFn = function imagesUploadHandler(blobInfo, success, failure) {
                                var xhr, formData;
                                xhr = new XMLHttpRequest();
                                xhr.open('POST', FILE_UPLOADER_URL + '/upload');
                                xhr.withCredentials = false;
                                xhr.timeout = 60000; //TODO: move this out to configuration, if we do it now though, won't be able to patch in december

                                function setIsBusy(isBusy) {
                                    var callbackFunction;

                                    if (attrs.busyCallback) {
                                        callbackFunction = $parse(attrs.busyCallback);
                                        callbackFunction(scope, {isBusy: isBusy});
                                    }
                                }

                                // on start of upload, we are busy
                                setIsBusy(true);

                                function failed(message) {
                                    setIsBusy(false);
                                    failure(message);
                                    scope.$broadcast('closeLoading',{remove:true});
                                }

                                function succeeded(link) {
                                    setIsBusy(false);
                                    success(link);
                                    updateView();
                                    scope.$broadcast('closeLoading');
                                }

                                xhr.onload = function() {
                                    var json;

                                    if (xhr.status !== 200) {
                                        failed('HTTP Error: ' + xhr.status);
                                        return;
                                    }
                                    json = JSON.parse(xhr.responseText);

                                    if (!json || typeof json.link !== 'string') {
                                        failed('Invalid JSON: ' + xhr.responseText);
                                        return;
                                    }
                                    succeeded(json.link);
                                };
                                xhr.ontimeout = function() {
                                    failed('HTTP Error: ' + xhr.status);
                                };
                                formData = new FormData();
                                formData.append('file', blobInfo.blob(), blobInfo.filename());
                                formData.append('renameFileWithTimestamp', true);
                                xhr.setRequestHeader('Authorization', CoreCompanyService.getAuthToken());
                                xhr.send(formData);
                            };

                            // assign/replace ID
                            attrs.$set('id', 'editor_' + randomEditorId);

                            // customOptions passed as directive parameters
                            if (attrs.tinymceEditorOptions) {
                                customOptions = scope.$eval(attrs.tinymceEditorOptions);
                            } else {
                                customOptions = {};
                            }

                            let tinyBaseUrl = ICM_ASSETS_URL +'client/js/lib/tinymce_v5';
                            options = {
                                // Update model after user actions
                                setup: function (editor) {
                                    editor.on('init', function () {
                                        ngModel.$render();

                                        // register method to be called on blur event
                                        if (customOptions.onBlurEvent && customOptions.context) {
                                            editor.on('blur', customOptions.onBlurEvent.bind(customOptions.context));
                                        }
                                    });

                                    // Update model on button click, keypress, blur
                                    editor.on('ExecCommand KeyUp blur', function () {
                                        editor.save();
                                        updateView();
                                    });

                                    // Update model on change, i.e. copy/pasted text, plugins altering content
                                    editor.on('SetContent', function (e) {
                                        if (!e.initial) {
                                            editor.save();
                                            updateView();
                                        }
                                    });

                                    // action when Image resized
                                    editor.on('ObjectResized', function(e) {
                                        if (e.target.nodeName === 'IMG') {
                                            $timeout($(e.target).removeAttr('data-mce-style').removeAttr('style'), 0);
                                        }
                                    });

                                    //icm_mailMerge button
                                    editor.ui.registry.addMenuButton('icm_mailMerge', {
                                        icon: 'user',
                                        fetch: function(callback){
                                            var items = [{
                                                type: 'menuitem',
                                                text: firstNameText,
                                                onAction: function firstNameFn() {
                                                    editor.insertContent('<span class="mceNonEditable">' + firstNamePlaceholder + '</span>');
                                                }
                                            }, {
                                                type: 'menuitem',
                                                text: lastNameText,
                                                onAction: function lastNameFn() {
                                                    editor.insertContent('<span class="mceNonEditable">' + lastNamePlaceholder + '</span>');
                                                }
                                            }];

                                            return callback(items);
                                        }
                                    });

                                    var inputFileId = 'file_' + randomEditorId;
                                    editor.ui.registry.addButton('icm_imageUploadV5', {
                                        icon: 'image',
                                        tooltip: 'Insert Image',
                                        onAction: function() {
                                            angular.element('#' + inputFileId).click();
                                        },
                                        onSetup: function() {
                                            var editorEventCallback = function () {
                                                //add a form to document.body with a single file input in it
                                                if (angular.element('input#' + inputFileId).length === 0) {
                                                    angular.element(document.body)
                                                        .append(
                                                            angular.element('<form/>')
                                                                .append(
                                                                    angular.element('<input/>')
                                                                        .attr('type', 'file')
                                                                        .attr('name', inputFileId)
                                                                        .attr('accept', imageUploadAcceptedTypes)
                                                                        .attr('id', inputFileId)
                                                                        .attr('style', 'display: none;') // this was adding a visible file selector on the page
                                                                )
                                                        );
                                                }
                                                angular.element('#' + inputFileId).on('change', function () {
                                                    if(angular.element(this).val().length > 0 && uploading === false) {
                                                        var imageBlob, blobObjectUrl, image,
                                                            imageId = 'image_' + Math.ceil(Math.random() * 10000 + 1),
                                                            file = $('#' + inputFileId)[0].files[0],
                                                            fileReader = new FileReader();

                                                        uploading = true;
                                                        // use the fileReader to upload a blob and attach the img element to tinyMCE
                                                        fileReader.onloadend = function whenFileReaderIsReady(event) {
                                                            imageBlob = new Blob([event.target.result], {type : file.type});
                                                            blobObjectUrl = window.URL.createObjectURL(imageBlob);

                                                            //let's use the blobObjectURL as src temporarily while we upload our image to S3, we'll then replace it with the actual URL
                                                            image = new Image();
                                                            image.addEventListener('load', function() {
                                                                editor.insertContent(
                                                                    angular.element('<img />')
                                                                        .attr('id', imageId)
                                                                        .attr('width', image.width)
                                                                        .attr('height', image.height)
                                                                        .attr('style', 'opacity: 0.3;')
                                                                        .attr('src', image.src)[0].outerHTML
                                                                );
                                                                editor.insertContent('<p></p>'); //breakline after inserting image
                                                                image = null;
                                                            }, false);
                                                            image.src = blobObjectUrl;

                                                            //reset the input file for further use
                                                            document.querySelector('input#' + inputFileId).value = '';

                                                            // //set a loading state right after loading image so the user knows there is something going on!
                                                            editor.notificationManager.open({
                                                                text: uploadingImageMessage,
                                                                type: 'info',
                                                                timeout: -1,
                                                                progressBar: false
                                                            });

                                                            scope.$on('closeLoading', function(event, args){
                                                                editor.notificationManager.close();
                                                                uploading = false;
                                                                if(args && args.remove){
                                                                    editor.$('#' + imageId).remove();
                                                                    DialogService.flashError(genericErrorMessage);
                                                                }
                                                            });
                                                        };

                                                        fileReader.readAsArrayBuffer(file);
                                                    }

                                                });
                                            };
                                            editor.on('NodeChange', editorEventCallback);
                                            /* onSetup should always return the unbind handlers */
                                            return function () {
                                                editor.off('NodeChange', editorEventCallback);
                                            };
                                        }
                                    });

                                    if (customOptions.setup) {
                                        scope.$eval(customOptions.setup);
                                        delete customOptions.setup;
                                    }
                                },
                                selector: 'textarea.editor',
                                base_url: tinyBaseUrl,
                                suffix: '.min',
                                menubar: false,
                                statusbar: false,
                                toolbar_drawer: 'sliding',
                                contextmenu: false,
                                // elements: attrs.id,
                                language: editorLanguage,
                                entity_encoding: 'raw',
                                /* jshint camelcase: false */
                                font_formats: 'Sans Serif=arial,helvetica,sans-serif;Serif=times new roman,serif;' + fixedStr + '=monospace,monospace;' + wideStr + '=arial black,sans-serif;' + narrowStr + '=arial narrow,sans-serif;Comic Sans MS=comic sans ms,sans-serif;Garamond=garamond,serif;Georgia=georgia,serif;Tahoma=tahoma,sans-serif;Trebuchet MS=trebuchet ms,sans-serif;Verdana=verdana,sans-serif;',
                                images_upload_handler: imageUploadHandlerFn,
                                /* jshint camelcase: false */
                                color_cols: 8,
                                color_map: editorColorMap,
                                invalid_styles: 'visibility overflow opacity',
                                init_instance_callback: function(editor) {
                                    //set focus on first input
                                    $('form *:input[type!=hidden][type!=file]:first').focus();

                                    // we are ignoring the scroll into view event, as it conflicted with our custom sticky header
                                    editor.on('ScrollIntoView', function(event) {
                                        event.stopPropagation();
                                        event.preventDefault();
                                    });

                                    if(attrs.stickTo) {
                                        var editorContainerElement = angular.element(editor.editorContainer),
                                            toolbarElement = editorContainerElement.find('.tox-editor-header'),
                                            stickToElement = angular.element(attrs.stickTo),
                                            debounceScroll = _.debounce(function() {
                                                if(editorContainerElement.position().top <= 0) {
                                                    toolbarElement.css('top', stickToElement.offset().top);
                                                    toolbarElement.addClass('stick');
                                                } else {
                                                    toolbarElement.removeClass('stick');
                                                }

                                            }, 10);

                                        stickToElement.on('scroll', debounceScroll);
                                    }

                                }
                            };

                            angular.extend(options, customOptions);

                            function initTiny() {
                                $timeout(function initializeEditor() {
                                    if(window.tinymce) {
                                        window.tinymce.init(options);
                                        editorInstance = window.tinymce.get(attrs.id);
                                    } else {
                                        initTiny();
                                    }
                                }, 50);
                            }
                            initTiny();


                            ngModel.$render = function () {
                                if(editorInstance && editorInstance.getDoc() && ngModel) {
                                    editorInstance.setContent(ngModel.$viewValue || '');
                                }
                            };

                            scope.$on('$destroy', function() {
                                if(editorInstance) {
                                    editorInstance.remove();
                                }

                                $('.textEditor').off('click');
                            });

                            updateView = function updateView() {
                                ngModel.$setViewValue(editorInstance.getContent());

                                $timeout(function applyChanges() {
                                    scope.$apply();
                                }, 0);
                            };

                        });
                    }
                };
            }
        ]);
}());
